<script>
export default {
    components: {},
};
</script>

<template>
<div class="background-app" :style="{ backgroundImage: 'url(' + require('@/assets/images/background.jpg') + ')'  }">
    <div class="row">
        <div class="col-md-12 col-lg-6 d-none d-sm-none d-md-block">
            <div class="row account-pages my-5 pt-5">
                <div class="col-xs-1 col-md-1 col-lg-1">
                </div>
                <div class="col-xs-10 col-md-10 col-lg-10 title">
                    Compromiso 
                    <br/>
                    en nuestros 
                    <br/>
                    platos.
                </div>
            </div>
        </div>
        <div class="col-md-12 col-lg-6 space">
            <div class="row pt-5 pb-5">
                <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
                </div>
                <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 container-app">
                    <slot />
                </div>
                <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style scoped>

</style>